import { useQuery } from '@tanstack/react-query';

// models
import { LabelModel } from '../../models/label.model';
import { AllVariantTypes, AllVariantType } from '../../models/variant.model';

// constants
import API from '../../services/api';

// hooks
import labelKeys from './_queryKeys';

const getAllLabels = async (active: boolean = false): Promise<LabelModel[]> => {
    const { data } = await API.getAllLabels(active);

    return data.items;
};

export default function useAllLabelsQuery(
    variant_type: AllVariantTypes,
    active: boolean = false,
) {
    return useQuery({
        queryKey: labelKeys.all(active),
        queryFn: () => getAllLabels(active),
        enabled: variant_type === AllVariantType.All,
    });
}
